import { Pipe, PipeTransform } from '@angular/core';
import '@shared/interfaces/date-extension'

import { AuthService } from '@services/auth.service';

@Pipe({
    name: 'timezoneconvertor'
})
export class TimeZoneConverter implements PipeTransform {
    timeZoneInfo: any;

    constructor() {
        let val = new AuthService().getUserTimeZone();
        if(val != "" && val != null && val != undefined)
            this.timeZoneInfo = JSON.parse(val);
    }

    /**
     * 
     * @param value date
     * @param submitValue true, will convert local date to UTC ISOString
     * @returns if submitValue is true then UTC date otherwise user timezone date(offset)
     */
    transform(value: Date, submitValue: boolean = false): any {
        try {
            let offset = 0;
            if (value == null || value == undefined)
                return value;

            value = new Date(value);
            if (this.timeZoneInfo != undefined && this.timeZoneInfo != null) {
                if (value >= new Date(this.timeZoneInfo.DSTStartDateTime) && value <= new Date(this.timeZoneInfo.DSTEndDateTime))
                    offset = this.timeZoneInfo.OnDSTHours + this.timeZoneInfo.OnDSTMinutes + this.timeZoneInfo.OnDSTSeconds;
                else
                    offset = this.timeZoneInfo.OffDSTHours + this.timeZoneInfo.OffDSTMinutes + this.timeZoneInfo.OffDSTSeconds;
            }
            
            if (submitValue) {
                value.setMinutes(value.getMinutes() - (offset * 60));
                return value.getISOString();
            } 
            value.setMinutes(value.getMinutes() + (offset * 60));
            return value;
        }
        catch {
            return value;
        }
    }
}